import { DefaultService } from '@/services/DefaultService';

export default class ContasReceberService extends DefaultService {

    constructor(http, router, env) {
        super(http, router, env);
    }

    findAll(filtros) {
        return this._http
        .post( encodeURI(`${this._env}/financeiro/contas-receber.json`), filtros, this._headers)
        .then(res => {
            return res.body;
        }, err => {
            this.handleError(err);
        });
    }

    find(id) {
        return this._http
        .get(`${this._env}/financeiro/contas-receber/${id}.json`, this._headers)
        .then(res => {
            return res.body;
        }, err => {
            this.handleError(err);
        });
    }

    findFull(id) {
        return this._http
        .get(`${this._env}/financeiro/contas-receber/full/${id}.json`, this._headers)
        .then(res => {
            return res.body;
        }, err => {
            this.handleError(err);
        });
    }

    findTotal(ini, fim) {
        return this._http
        .get(`${this._env}/financeiro/contas-receber/${ini}/${fim}/total.json`, this._headers)
        .then(res => {
            return res.body;
        }, err => {
            this.handleError(err);
        });
    }

}